import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import DocumentsRow from "./DocumentsRow";
import DocumentEditDialog from "./DocumentEditDialog";
import {randHex} from "../../Form/utils";

const DocumentsTable = (props) => {
    const {entity, files, removingFile, meta, classes} = props;

    const[fileList,setFileList] = useState(null)
    const changeFileList = list => setFileList(list);

    useEffect(() => {
        changeFileList(files);
    },[files]);

    const removeFile = fileToRemove => {
        if(fileToRemove) {
            let newList = fileList.filter(file => file.iId !== fileToRemove.iId)
            setFileList(newList);
            removingFile(fileToRemove);
        }
    }

    // data passes from DocumentEditDialog
    const changeFileData = data => {

        let newList = fileList && fileList.map((file) => {
            if (file.iId === data.iId) {
                // changes alias in aRelations
                file.aRelations.length && file.aRelations.forEach((relation,key) => {
                    if(relation.id === data.rId){
                        file.aRelations[key] = {
                            ...file.aRelations[key],
                            alias: data.sName,
                        }
                    }
                });
                // changes oType from file
                if(!file.oType || (data.docType && parseInt(file.oType.id) !== parseInt(data.docType.id)) ) {
                    file.oType = {
                        ...data.docType
                    };
                }
                return {...file};
            }
            return file;
        });

        setFileList(newList);
    }

    const [dialog,setDialog] = useState({open :false,entity:null,file:null});

    const openDialog = (file) => {
        setDialog({open :true, entity:entity, file: file});
    };
    const closeDialog = () => {
        setDialog( { open :false, entity:null, file:null } );
    };

    return (
        fileList && fileList.length ? (
            <React.Fragment>
                <Table className={classes.list}>
                    <TableHead>
                        <TableRow style={{background:'unset',}}>
                            <TableCell>{i18n.get('file.document.name')}</TableCell>
                            {!meta && (
                                <React.Fragment>
                                    <TableCell style={{ width:'20%' }} align="center">{i18n.get('file.document.type')}</TableCell>
                                    <TableCell style={{ width:'20%' }} align="center">{i18n.get('file.document.created_at')}</TableCell>
                                </React.Fragment>
                            )}
                            <TableCell style={{ width:'15%' }} align="center">{i18n.get('file.document.actions')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {fileList && fileList.map(file => {
                            return <DocumentsRow
                                meta={meta}
                                entity={entity}
                                file={file}
                                openDialog={openDialog}
                                key={`file_${file.iId || randHex(6)}`}
                                changeFileList={changeFileList}
                                removeFile={removeFile}
                            />
                        })}
                    </TableBody>
                </Table>
                <DocumentEditDialog closeDialog={closeDialog} dialog={dialog} changeFileData={changeFileData} />
            </React.Fragment>
        ) : i18n.get('default.empty')
    );
}

const styles = theme => ({
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        },
    },
});

export default withStyles(styles)(DocumentsTable);
